import type { IControlSettingUI } from '../types';

import {
  SelectInline,
  SelectDropdown,
  SelectCompound,
  SectionCard,
  SelectPage,
  SelectCampaign,
  SelectBase,
} from '~/presentation/reports/ui';
import { SelectCampaignItem } from '~/presentation/reports/ui/SelectCampaignItem';
import { EControlType } from '../types';

type ExtractByType<Union, Type> = Union extends { type: Type } ? Union : never;

type ControlTypeToPropsMap = {
  [K in EControlType]: ExtractByType<IControlSettingUI, K>;
};

export function getComponent<T extends IControlSettingUI>(data: T) {
  const CONTROL_COMPONENT_MAP: {
    [K in EControlType]: React.FC<ControlTypeToPropsMap[K]>;
  } = {
    [EControlType.SELECT_INLINE]: SelectInline,
    [EControlType.SELECT_DROPDOWN]: SelectDropdown,
    [EControlType.SELECT_COMPOUND]: SelectCompound,
    [EControlType.SECTION_CARD]: SectionCard,
    [EControlType.SELECT_PAGE]: SelectPage,
    [EControlType.SELECT_CAMPAIGN]: SelectCampaign,
    [EControlType.SELECT_CAMPAIGN_ITEM]: SelectCampaignItem,
    [EControlType.SELECT_BASE]: SelectBase,
  };

  return CONTROL_COMPONENT_MAP[data.type] as React.FC<T>;
}
